module.exports = __webpack_public_path__ + "img/Medical Science.32bc66b3.jpg";